import { FC } from 'react';
import { Column } from 'primereact/column';
import { formatNumber } from '@agro1desenvolvimento/utils-js';
import { DataTableExpandedRows } from 'primereact/datatable';
import AutoSortTable from '../../../../../components/AutoSortTable';
import defaultColumnProps from '../../../../../utils/default-column-props';
import humanizeDate from '../../../../../utils/humanize-date';
import { humanizePesoComPms, isSegundoTratamento } from '../../utils';
import { TratamentoFormValue } from '../../../../../@types';
import TratamentoDeSementesResumoRowExpansion from '../row-expansion';

const GeneralInfoTable: FC<GeneralInfoTableProps> = ({
  tratamentos,
  expandedRows,
}) => (
  <AutoSortTable
    removableSort
    sortField="dataInicio"
    dataKey="identification"
    value={tratamentos}
    className="data-table col-10"
    emptyMessage="Nenhum tratamento adicionado."
    expandedRows={expandedRows}
    rowExpansionTemplate={TratamentoDeSementesResumoRowExpansion}
    stripedRows
  >
    <Column expander hidden className="row-expander" />
    <Column
      {...defaultColumnProps()}
      header="Data Início"
      field="dataInicio"
      body={(tratamento) => humanizeDate(tratamento.dataInicio)}
    />
    <Column
      {...defaultColumnProps()}
      header="Data Término"
      field="dataFim"
      body={(tratamento) => humanizeDate(tratamento.dataFim)}
    />
    <Column
      {...defaultColumnProps('left')}
      field="sementeOrigem.descricao"
      body={(tratamento) =>
        tratamento.sementeOrigem?.descricao || 'INSUMO INDISPONÍVEL'
      }
      header="Semente de Origem"
    />
    <Column
      {...defaultColumnProps('left')}
      field="sementeDestino.descricao"
      header="Semente de Destino"
    />
    <Column
      {...defaultColumnProps()}
      header="Total"
      field="quantidade"
      body={(tratamento) => {
        if (isSegundoTratamento(tratamento)) return 'Tudo';

        const formattedQuantidade = formatNumber(tratamento.quantidade || 0, {
          maximumFractionDigits: 4,
        });
        const unidade = tratamento.unidade?.abreviatura || '';
        return `${formattedQuantidade} ${unidade}`;
      }}
    />
    <Column
      {...defaultColumnProps('left')}
      header="Peso (kg)"
      body={({ unidade, quantidade, pms }) =>
        humanizePesoComPms({ unidade, quantidade, pms })
      }
    />
  </AutoSortTable>
);

export default GeneralInfoTable;

type GeneralInfoTableProps = {
  tratamentos: TratamentoFormValue[];
  expandedRows: DataTableExpandedRows | undefined;
};
